/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BookmarksWidgetContainer_widget$ref: FragmentReference;
export type BookmarksWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: BookmarksWidgetContainer_widget$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BookmarksWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visible",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "data",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '514961423238dba8006dc6e5f4f9fbf8';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Bookmarks/__generated__/BookmarksWidgetContainer_widget.graphql.js